import { useSelector } from 'react-redux';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps, getPostVerificationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { Step } from '../views/Step';
import { useCurrentStep } from './useCurrentStep';
import { shouldShowEmptyContent } from '../messaging/utils/shouldShowEmptyContent';
import { getIsInCam0001VariantA } from '../experiments/cam0001/cam0001Utils';
import { getIntentKey } from '../routing/getIntentKey';
import { Intent } from 'signup-constants/Intent';
export const useIsFramedCentredStep = () => {
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const isFramedCentredStep = stepConfig && stepConfig.isFramedCentredStep || false;
  const activeLoading = useSelector(getActiveLoading);
  const postVerificationSteps = useSelector(getPostVerificationSteps);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const isPostAccountCreationStep = postAccountCreation.includes(currentStep);
  const intentKey = getIntentKey();

  if (step === Step.LandingPage && getIsInCam0001VariantA() && intentKey === Intent.campaignAssistant) {
    return {
      isFramedCentredStep: false
    };
  } // In the Wordpress flow, the CRM Experience step is before account creation


  if (step === Step.CrmExperienceLevel && postVerificationSteps.includes(Step.CrmExperienceLevel)) {
    return {
      isFramedCentredStep: true
    };
  }

  if (currentStep === Step.GoogleContactsSync) {
    return {
      isFramedCentredStep: true
    };
  }

  if (activeLoading || isPostAccountCreationStep || activeError || !isFramedCentredStep) {
    return {
      isFramedCentredStep: false
    };
  }

  if (shouldShowEmptyContent()) {
    return {
      isFramedCentredStep: true
    };
  }

  return {
    isFramedCentredStep
  };
};